var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlugOffDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5223 4.992V2.25H10.533V4.992H7.467V2.25H6.47775V4.992H4.5V10.371C4.5 12.1155 5.83125 13.5352 7.467 13.5352H8.50575V15.75H9.49425V13.5352H10.533C12.1687 13.5352 13.5 12.1155 13.5 10.371V4.992H11.5223ZM12.5107 10.371C12.5107 11.5343 11.6235 12.4808 10.533 12.4808H7.467C6.3765 12.4808 5.48925 11.5343 5.48925 10.371V6.04725H12.5107V10.371Z",
    fill: "#111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5L9 9M7.5 10.5L9 9M9 9L7.5 7.5L10.5 10.5",
    stroke: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugOffDark);
export default __webpack_public_path__ + "static/media/plug-off-dark.c84372e4d2295681d269858531ee9c42.svg";
export { ForwardRef as ReactComponent };